import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { ConfigurationService } from '../../../../services/config.service';
var signupComponent = /** @class */ (function () {
    function signupComponent(activeModal, authAPIs, configAPIs, localSt, router) {
        this.activeModal = activeModal;
        this.authAPIs = authAPIs;
        this.configAPIs = configAPIs;
        this.localSt = localSt;
        this.router = router;
        this.aboutList = [];
        this.showMsg = '';
        this.showErrorMsg = false;
        this.showLoader = false;
        // public lowerCase = false;
        // public upperCase = false;
        this.oneLetter = false;
        this.specialNumeric = false;
        this.minCharacterCheck = false;
        this.showOtherField = false;
        this.otherFieldButtonDisable = false;
        this.showPasswordError = false;
        this.showEmailError = false;
    }
    signupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.createForm();
        this.configAPIs.getConfigurations().subscribe(function (res) {
            _this.aboutList = res.data.zf_heard_about_options;
        }, function (error) {
            // console.log(error);
        });
    };
    signupComponent.prototype.createForm = function () {
        this.signupForm = new FormGroup({
            firstName: new FormControl('', [Validators.required, Validators.minLength(1)]),
            lastName: new FormControl('', [Validators.required, Validators.minLength(1)]),
            email: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
            password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
            pwdAgain: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
            heardBy: new FormControl('', [Validators.required]),
            other: new FormControl('', [Validators.maxLength(20)])
        });
    };
    signupComponent.prototype.closeModal = function () {
        this.activeModal.close();
    };
    signupComponent.prototype.hearAboutUsChange = function () {
        if (this.signupForm.value.heardBy === 'Others' || this.signupForm.value.heardBy === 'Other') {
            this.showOtherField = true;
            this.otherFieldButtonDisable = true;
        }
        else {
            this.showOtherField = false;
            this.otherFieldButtonDisable = false;
        }
    };
    signupComponent.prototype.hearAboutUsValidation = function () {
        if (this.signupForm.value.other === '') {
            this.otherFieldButtonDisable = true;
        }
        else {
            this.otherFieldButtonDisable = false;
        }
    };
    signupComponent.prototype.signupFun = function () {
        var _this = this;
        if (this.signupForm.value.heardBy === 'Others' || this.signupForm.value.heardBy === 'Other') {
            this.signupForm.value.heardBy = 'Others - ' + this.signupForm.value.other;
        }
        else {
            delete this.signupForm.value.other;
        }
        this.showLoader = true;
        this.userObject(this.signupForm.value, function (err, result) {
            _this.authAPIs.signup(result).subscribe(function (res) {
                _this.showLoader = false;
                if (res.statusCode === 200 && res.success === true) {
                    _this.localSt.clear('zenUser');
                    _this.localSt.store('zenUser', res.data);
                    _this.activeModal.close();
                }
                else if (res.statusCode === 105 && res.success === false) {
                    _this.showErrorMsg = true;
                    _this.showMsg = res.message;
                }
                else {
                    // console.log(res.message);
                }
            }, function (error) {
                if (error.status === 0) {
                    _this.activeModal.close();
                    _this.router.navigate(['/no-internet']);
                }
            });
        });
    };
    signupComponent.prototype.userObject = function (formValue, callback) {
        var obj = {};
        obj['first_name'] = formValue.firstName;
        obj['last_name'] = formValue.lastName;
        obj['email'] = formValue.email;
        obj['password'] = formValue.password;
        obj['heard_by'] = formValue.heardBy;
        callback(null, obj);
    };
    signupComponent.prototype.onPwdChange = function (value) {
        this.showPasswordError = true;
        value.length < 8 ? this.minCharacterCheck = false : this.minCharacterCheck = true;
        value.search(/[a-z]/) !== -1 ? this.oneLetter = true : this.oneLetter = false;
        // value.search(/[a-z]/) !== -1 ? this.lowerCase = true : this.lowerCase = false;
        // value.search(/[A-Z]/) !== -1 ? this.upperCase = true : this.upperCase = false;
        value.search(/[0-9!@#$%^&*()_+`~,.<>;‘:“/[\]|{}=-]/) !== -1 ? this.specialNumeric = true : this.specialNumeric = false;
    };
    signupComponent.prototype.emailValidation = function () {
        this.signupForm.controls.email.errors !== null ? this.showEmailError = true : this.showEmailError = false;
    };
    return signupComponent;
}());
export { signupComponent };



// WEBPACK FOOTER //
// ./src/app/modules/user/auth/signup/signup.component.ts.pre-build-optimizer.js